import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/psx-frontend/psx-frontend/app/scanner/liquidity-sweep/LiquiditySweepClient.tsx");
